export const AUDIT_ACTIONS = [
  'tenant.create', 'tenant.update', 'tenant.suspend', 'tenant.reactivate',
  'warehouse.create', 'warehouse.update',
  'membership.add', 'membership.remove',
  'user.disable', 'user.enable',
  'item_schema.create', 'item_schema.activate',
  'dialog_template.create', 'dialog_template.activate',
  'picklist.import', 'picklist.cancel',
  'mission.start', 'mission.complete', 'mission.cancel',
  'task.confirm', 'task.skip',
  'session.start', 'session.end',
] as const;
export type AuditAction = typeof AUDIT_ACTIONS[number];

export const AUDIT_ENTITY_TYPES = [
  'tenant', 'user', 'warehouse', 'item_schema', 'dialog_template',
  'item', 'picklist', 'mission', 'task', 'session',
] as const;
export type AuditEntityType = typeof AUDIT_ENTITY_TYPES[number];
